define('casino/providers/Evolution',['jquery'], function ($) {
    'use strict';

    function Evolution(casino, gameFunctions) {
        if (!(this instanceof Evolution)) {
            throw new TypeError('Evolution constructor cannot be called as a function.');
        }

        this.casino = casino;
        this.gameFunctions = gameFunctions;
    }

    function freeMode(evolution, game, options) {
        evolution.gameFunctions.hideHelpButton();
        evolution.gameFunctions.showNoFreeMode(options.gameHolder, game);

    }

    function realMode(evolution, game, options, data) {
        evolution.gameFunctions.hideHelpButton();

        var splitIdAndCode = game.code.split('_');
        if (splitIdAndCode[0] !== 'EVO') {
            throw new Error('Illegal game code not starting with EVO: ' + game.code);
        }
        window.addEventListener('message', function (e) {
            var $gameHolder = options.gameHolder;
            var frameID = 'loaded-game-' + $gameHolder.index();
            var frame = document.getElementById(frameID);
            if (e.data === 'changeForStandart') {
                // When switching back to regular games height and width
                // should be set back to 800x680
                frame.width = '800';
                frame.height = '680';
            } else if (e.data === 'changeForImmersive') {
                // For better user experience height and width should be calculated
                // on operator side to use as much screen space as possible
                // keeping ratio 1920x1080
                frame.width = '1200';
                frame.height = '675';
            } else if (e.data === 'changeForMultiWindow') {
                // For better user experience height and width should be calculated
                // on operator side to use as much screen space as possible
                frame.width = '1200';
                frame.height = '1020';
            }
        }, false);

        evolution.gameFunctions.switchToRealMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: data.page
        });
        evolution.gameFunctions.verifyCurrency(data.currency);
    }

    Evolution.prototype = {
        constructor: Evolution,
        freeMode: function (game, options) {
            freeMode(this, game, options);
        },
        realMode: function (game, options, data) {
            realMode(this, game, options, data);
        }
    };

    return Evolution;
});
